import initMemoryFilters from './components/memory-filters';
import initFetchContent from './components/fetch-content';

const memorySection = document.querySelector('.js-memories');

if (memorySection) {
    initMemoryFilters(memorySection);
}

const fetchContainer = document.querySelector('.js-fetch-container');
const fetchLinks = document.querySelectorAll('.js-fetch');

if (fetchContainer && (fetchLinks && fetchLinks.length > 0)) {
    initFetchContent(fetchContainer, fetchLinks);
}
